const moreStoriesContainer = document.querySelector("#more-stories");
const loadMoreBtn = document.querySelector("#load-stories-btn");
const loadMoreWrapper = document.querySelector("#load-stories-wrapper");

loadMoreBtn.addEventListener("click", () => {
    moreStoriesContainer.classList.add("loaded");
    loadMoreWrapper.classList.add("d-none");
});
